import React from "react";
import { projectsData } from "./Data";
import WorkItem from "./WorkItem";

const Works = () => {
  return (
    <div>
      {/* <div className="work__filters">
        {projectNav.map((cat, index) => {
          return (
            <span className="work__item" key={index}>
              {cat.name}
            </span>
          );
        })}
      </div> */}

      <div className="work__container container grid">
        {projectsData.map((project) => {
          return <WorkItem project={project} key={project.id} />;
        })}
      </div>
    </div>
  );
};

export default Works;
